import datos from "src/services/datos";

import esArray from "src/general_components/functionEsArray";
import "src/services/styles/sweetAlert.css"


export const getInformes = async (auth) => {
    const prd_orden_produccion = new datos("prd_orden_produccion");
    prd_orden_produccion.addCondition("prd_orden_produccion", "id", 0, ">");
    const response = await prd_orden_produccion.get();
    return esArray(response.wsResponse.prd_orden_produccion);
};

export const getInformesPaginated = async (limit, offset) => {
    const prd_orden_produccion = new datos("prd_orden_produccion");
    prd_orden_produccion.addCondition("prd_orden_produccion", "id", 0, ">");
    prd_orden_produccion.join("prd_equipos", "id_prd_orden_produccion", "id", "=");
    prd_orden_produccion.innerJoinTables('articulos', 'prd_equipos', "id", "id_articulos", "=")
    prd_orden_produccion.join("cuentas_localizaciones", "id", "id_cuentas_localizaciones", "=");
    prd_orden_produccion.innerJoinTables('cuentas_personas_juridicas', 'cuentas_localizaciones', "id_cuentas", "id_cuentas", "=")
    prd_orden_produccion.join("prd_estados", "id", "id_prd_estados", "=");
    prd_orden_produccion.join("prd_mano_obra", "id_prd_orden_produccion", "id", "=");
    prd_orden_produccion.innerJoinTables('cuentas_personas_fisicas', 'prd_mano_obra', "id_cuentas", "id_cuentas", "=");
    // prd_orden_produccion.join("prd_orden_produccion_detalle", "id_prd_orden_produccion", "id", "=");
    // prd_orden_produccion.innerJoinTables('prd_detenciones', 'prd_orden_produccion_detalle', "id_prd_orden_produccion_detalle", "id", "=");
    // prd_orden_produccion.innerJoinTables('prd_mermas', 'prd_orden_produccion_detalle', "id_prd_orden_produccion_detalle", "id", "=");
    prd_orden_produccion.addOrderCondition("prd_orden_produccion", "id", "desc")
    prd_orden_produccion.addLimitCondition(limit, offset);
    const response = await prd_orden_produccion.get();
    /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

    let result = {};
    if (!response.wsResponse.empty) {
        result = {
            data: modificarEstructura(esArray(response.wsResponse.prd_orden_produccion)),
            total_records: response.wsResponse.total_records,
        };
        return result;
    }
};

const modificarEstructura = (data) => {
    return data.map(item => {
        const articulos = esArray(item.articulos);
        const tecnico = `${articulos[0].tecnico?.nombre}`;
        const cliente_name = articulos[0].cliente.nombre;
        const maquina_name = articulos[0].maquina.nombre;
        const estado = item.estado;

        return {
            ...item,
            tecnico,
            cliente_name,
            estado,
            maquina_name
        };
    });
};

export const getInformeDetalle = async (id_informe) => {
    const prd_orden_produccion = new datos("prd_orden_produccion");
    const data = {
        "id": id_informe? id_informe : false,
        "numero": false,
        "id_cuentas": false
    }
    
    const response = await prd_orden_produccion.produccionGet(data);
    return response.wsResponse.informes;
};


export const getInformesPaginated2 = async (limit, offset, filtros) => {
    let usuarioLogeado = JSON.parse(localStorage.getItem("siam-user-data"));
    const idPerfilUsuarioLogeado = usuarioLogeado.id_perfiles;

    console.log('getInformesPaginated2 - Filtros', filtros);
    const prd_orden_produccion = new datos("prd_orden_produccion");
    const data = {
        "filtraUser": "0",
        "numero": String(filtros?.numero || ""),
        "id_cuentas": String(filtros?.usuario?.id || filtros?.cliente?.id_cuentas || ""),
        "id_usuario": String(usuarioLogeado?.id || ""),
        "id_tecnico": String(filtros?.tecnico?.id || ""),
        "estado": String(filtros?.estado?.id || ""),
        "fecha_desde": String(filtros?.fechaDesde || ""),
        "fecha_hasta": String(filtros?.fechaHasta || ""),
        "maquina": String(filtros?.maquina?.id || ""),
        "fruta": String(filtros?.fruta?.id || ""),
        "limit": String(limit),
        "offset": String(offset),
        // ...(idPerfilUsuarioLogeado === "6" && { "estado": "1" }) // Agrega la propiedad estado solo si idPerfilUsuarioLogeado es 6
    };
    
    const response = await prd_orden_produccion.produccionGet(data);

    let result = {};
    if (!response.wsResponse.empty) {
        result = {
            data: modificarEstructura(esArray(response.wsResponse.informes)),
            total_records: response.wsResponse.total_records || 0,
        };
        return result;
    }
};

